import { FC, ReactNode } from 'react';
import { renderTruncateText } from 'src/utils/truncate-text';

interface Props {
  text: string;
  children: ReactNode;
  maxLength?: number;
}

export const TruncatedTextWithChildren: FC<Props> = ({ text, maxLength, children }) => {
  const { truncatedText, isTruncated } = renderTruncateText(text, maxLength);

  return (
    <>
      {truncatedText}
      {isTruncated ? children : null}
    </>
  );
};
